module.exports = __webpack_public_path__ + "img/logo-dark.a6db6a6d.jpg";